import { useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

// Datasets have <=10 prefixes, so a single page request is enough
const PAGE_SIZE = 50;

export interface DatasetFileConfig {
  id: string;
  prefix: string;
  // TODO: expose access_level and created_at, once the UI is ready to use those
}

// The catalog `GET /api/catalog/v1/datasets/{dataset_id}/file-prefixes` response.
// Keys stay snake_case because useFetcher fetches without camelization.
interface DatasetFilePrefixListResponse {
  metadata: {
    limit: number;
    offset: number;
    total_count: number;
    sort?: string;
    has_more: boolean;
  };
  items: DatasetFileConfig[];
}

interface UseDatasetPrefixesOptions {
  // Set false to hold the request — the endpoint requires ANALYZE, so a caller that knows
  // it only has preview access should skip it rather than take a 403.
  enabled?: boolean;
}

const useDatasetPrefixes = (id?: string, { enabled = true }: UseDatasetPrefixesOptions = {}) => {
  const { datasetId = id } = useParams();
  const query = new URLSearchParams({ limit: String(PAGE_SIZE), offset: "0" });
  const resp = useFetcher<DatasetFilePrefixListResponse>(
    enabled
      ? `${VITE_CATALOG_API}/v1/datasets/${datasetId}/file-prefixes?${query.toString()}`
      : null
  );

  return { ...resp, data: resp.data?.items };
};

export default useDatasetPrefixes;
